export const starRatingIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="23"
    height="24"
    viewBox="0 0 23 24"
    fill="none"
  >
    <path
      d="M10.5489 3.42705C10.8483 2.50574 12.1517 2.50574 12.4511 3.42705L13.8574 7.75532C13.9913 8.16734 14.3752 8.4463 14.8085 8.4463H19.3595C20.3282 8.4463 20.731 9.68592 19.9473 10.2553L16.2654 12.9303C15.9149 13.185 15.7683 13.6364 15.9021 14.0484L17.3085 18.3766C17.6078 19.298 16.5533 20.0641 15.7696 19.4947L12.0878 16.8197C11.7373 16.565 11.2627 16.565 10.9122 16.8197L7.23037 19.4947C6.44665 20.0641 5.39217 19.298 5.69153 18.3766L7.09787 14.0484C7.23174 13.6364 7.08508 13.185 6.7346 12.9303L3.05275 10.2553C2.26904 9.68592 2.67181 8.4463 3.64053 8.4463H8.19155C8.62477 8.4463 9.00873 8.16734 9.1426 7.75532L10.5489 3.42705Z"
      fill="#CACACA"
    />
  </svg>
);

export const aiStarIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M10.4288 1.60369C10.7561 1.60369 11.0545 1.80584 11.1739 2.11195L13.3147 7.54102L18.7438 9.68185C18.8931 9.74123 19.0212 9.84408 19.1115 9.97708C19.2017 10.1101 19.25 10.2671 19.25 10.4279C19.25 10.5886 19.2017 10.7456 19.1115 10.8786C19.0212 11.0116 18.8931 11.1145 18.7438 11.1739L13.3147 13.3147L11.1739 18.7438C11.1145 18.8931 11.0116 19.0212 10.8786 19.1115C10.7456 19.2017 10.5886 19.25 10.4279 19.25C10.2671 19.25 10.1101 19.2017 9.97709 19.1115C9.84408 19.0212 9.74123 18.8931 9.68185 18.7438L7.54102 13.3147L2.11195 11.1739C1.96258 11.1145 1.83448 11.0116 1.74423 10.8786C1.65397 10.7456 1.60572 10.5886 1.60572 10.4279C1.60572 10.2671 1.65397 10.1101 1.74423 9.97708C1.83448 9.84408 1.96258 9.74123 2.11195 9.68185L7.54102 7.54102L9.68185 2.11195C9.74163 1.9625 9.84465 1.8343 9.97773 1.74376C10.1108 1.65321 10.2679 1.60444 10.4288 1.60369ZM3.20931 0L4.22967 2.18703L6.4167 3.20739L4.22967 4.22967L3.20931 6.4167L2.18896 4.22967L0 3.20931L2.18703 2.18896L3.20931 0Z"
      fill="var(--custom-ai-summary-icon-color, #F37053)"
    />
  </svg>
);
